import { CostAnomalyAlertsDataGridDataType } from "../../../../../../../../store/alerts/utils/types/types";

export const isCostAnomalyAlertsDataGridDataType = (
  data: any,
): data is CostAnomalyAlertsDataGridDataType => {
  return !!data.view_id;
};
